import styled from '@emotion/styled';
import Typography from '@material-ui/core/Typography';
import { createElement, FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_UNIT } from '../../../constant/spacing';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';

type Props = {
  height?: number;
  className?: string;
};

const EmptyState: FC<Props> = ({ height, className }) => {
  return (
    <EmptyStateWrapper height={height} className={className}>
      <SubHeading color="textSecondary" variant="body1">
        <FormattedMessage id="performance_report_headline.no_data" />
      </SubHeading>
    </EmptyStateWrapper>
  );
};

const SubHeading = styled(Typography)({
  marginBottom: SPACING_UNIT,
  fontWeight: 400,
});

const EmptyStateWrapper = styled('div')<{ height?: number }>((props: { height?: number }) => ({
  ...flexibleLayoutContainer({
    justifyContent: 'center',
    alignItems: 'center',
  }),
  height: props.height || 200,
}));

export default EmptyState;
